/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassCalendarItem } from './ClassCalendarItem';
import {
    ClassCalendarItemFromJSON,
    ClassCalendarItemFromJSONTyped,
    ClassCalendarItemToJSON,
    ClassCalendarItemToJSONTyped,
} from './ClassCalendarItem';

/**
 * 
 * @export
 * @interface ClassesCalendarWidgetData
 */
export interface ClassesCalendarWidgetData {
    /**
     * 
     * @type {Array<ClassCalendarItem>}
     * @memberof ClassesCalendarWidgetData
     */
    items: Array<ClassCalendarItem>;
}

/**
 * Check if a given object implements the ClassesCalendarWidgetData interface.
 */
export function instanceOfClassesCalendarWidgetData(value: object): value is ClassesCalendarWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ClassesCalendarWidgetDataFromJSON(json: any): ClassesCalendarWidgetData {
    return ClassesCalendarWidgetDataFromJSONTyped(json, false);
}

export function ClassesCalendarWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassesCalendarWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClassCalendarItemFromJSON)),
    };
}

export function ClassesCalendarWidgetDataToJSON(json: any): ClassesCalendarWidgetData {
    return ClassesCalendarWidgetDataToJSONTyped(json, false);
}

export function ClassesCalendarWidgetDataToJSONTyped(value?: ClassesCalendarWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClassCalendarItemToJSON)),
    };
}

